var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncrease15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 31,
    viewBox: "0 0 46 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5452 9.30431C44.9812 9.81987 44.1058 9.77835 43.5903 9.21435L39.9918 5.2733V23.7502C39.9918 24.7052 39.2167 25.4803 38.2617 25.4803H19.3039C18.3489 25.4803 17.5738 24.7052 17.5738 23.7502V12.8059H3.46009V29.2621C3.46009 30.2171 2.68503 30.9922 1.73005 30.9922C0.775061 30.9922 0 30.2171 0 29.2621V11.0759C0 10.1209 0.775061 9.34583 1.73005 9.34583H19.3039C20.2589 9.34583 21.0339 10.1209 21.0339 11.0759V22.0202H36.5351V4.9965L32.255 9.06211C31.7014 9.58804 30.826 9.56728 30.3 9.01366C29.7741 8.46005 29.7949 7.58464 30.3485 7.05525L36.6839 1.03469C36.9538 0.425709 37.5593 0.000118256 38.2652 0.000118256C38.279 0.000118256 38.2894 0.00357819 38.3032 0.00357819C38.3102 0.00357819 38.3171 0.00357819 38.324 0.00357819C38.4174 0.00357819 38.5109 0.0139561 38.6008 0.0312576C38.632 0.0381775 38.6596 0.0485573 38.6873 0.058939C38.7461 0.0762386 38.8084 0.0900803 38.8672 0.114302C39.279 0.266544 39.6146 0.571033 39.8084 0.962023L45.6386 7.34936C46.1542 7.91335 46.1127 8.78876 45.5487 9.30431H45.5452Z",
    fill: "#F3A890"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease15);
export default __webpack_public_path__ + "static/media/increase15.b8b9908ebade48b0d95130f426ab00c1.svg";
export { ForwardRef as ReactComponent };